import React, { useState } from "react";

export const ManageSeasonModal = ({ popstatus, handleClose , StoreDataSeason }) => {
  const [season, setSeason] = useState({
    seasonName: "",
    seasonStartDate: "",
    seasonEndDate: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSeason({ ...season, [name]: value });

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = () => {
    const newErrors = {};

    if (!season.seasonName.trim()) {
      newErrors.seasonName = "Season name is required";
    }
    if (!season.seasonStartDate.trim()) {
      newErrors.seasonStartDate = "Start date is required";
    }
    if (!season.seasonEndDate.trim()) {
      newErrors.seasonEndDate = "End date is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    handleClose();
    StoreDataSeason(season)
    setSeason({
      seasonName: "",
      seasonStartDate: "",
      seasonEndDate: "",
    })
  };

  return (
    <div className="manage_season_modal">
      {popstatus && (
        <div className="chagepassword-popup">
          <div className="chagepassword-content">
            <i className="fa-solid fa-xmark" onClick={handleClose}></i>
            <div className="chagepass-popupcontent">
              <h1>Create Season</h1>
              <p>Fill the season details below.</p>

              <div className="form-row">
                {/* Season Name */}
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control custom-height"
                    placeholder="Season Name"
                    name="seasonName"
                    value={season.seasonName}
                    onChange={handleChange}
                  />
                </div>

                <p className="text-danger">{errors.seasonName}</p>

                {/* Start Date */}
                <label htmlFor="seasonStartDate" className="form-label">
                  Start Date
                </label>

                <div className="input-group">
                  <input
                    type="date"
                    className="form-control custom-height"
                    name="seasonStartDate"
                    value={season.seasonStartDate}
                    onChange={handleChange}
                  />
                </div>

                <p className="text-danger">{errors.seasonStartDate}</p>

                {/* End Date */}
                <label htmlFor="seasonEndDate" className="form-label">
                  End Date
                </label>

                <div className="input-group">
                  <input
                    type="date"
                    className="form-control custom-height"
                    name="seasonEndDate"
                    value={season.seasonEndDate}
                    onChange={handleChange}
                  />
                </div>

                <p className="text-danger">{errors.seasonEndDate}</p>
              </div>

              <div className="form-row w-100">
                <button
                  type="submit"
                  className="users_btn change-passbtn"
                  onClick={handleSubmit}
                >
                  Save Season
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
